import { startOfMonth, startOfWeek, endOfMonth, endOfWeek, startOfDay, addDays } from "date-fns";

const daysInWeek = 7;

export const generateWeek = (start = new Date()) => {
  const date = startOfWeek(startOfDay(start), { weekStartsOn: 1 });

  return [...Array(daysInWeek)].map((_, i) => addDays(date, i));
};

export const generateMonth = (start = new Date()) => {
  const month = [];
  const date = start;
  const firstWeek = generateWeek(startOfMonth(date));
  const endDate = startOfDay(endOfWeek(endOfMonth(date), { weekStartsOn: 1 }));

  let firstDayOfWeek = firstWeek[0];
  while (firstDayOfWeek < endDate) {
    month.push(generateWeek(firstDayOfWeek));
    firstDayOfWeek = addDays(firstDayOfWeek, daysInWeek);
  }

  return month;
};
